import createGetFormValues from './selectors/getFormValues';
import plain from './structure/plain';

export default createGetFormValues(plain);


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/redux-form/es/getFormValues.js
// module id = 1221
// module chunks = 4